import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import {
    ANIMATION_BIGGER,
    ANIMATION_SMALLER,
    conditionalScaleAnimation
} from 'libs/styles/animations';
import { EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    icon: {
        iconPrefix: IconPrefix;
        iconName: IconName;
    };

    title: string;
    expandable?: boolean;
    expanded?: boolean;
    onExpandClick?: () => void;
}

export const SidebarSubsectionHeader = (props: Props): JSX.Element => {
    return (
        <S_SidebarSubsectionHeader
            $expandable={props.onExpandClick ? true : false}
            className={props.className}
            onClick={() => {
                if (props.expandable) props.onExpandClick?.();
            }}
        >
            {props.icon && <S_HeaderIcon icon={[props.icon.iconPrefix, props.icon.iconName]} />}
            <S_HeaderTitle>{props.title}</S_HeaderTitle>
            {props.expandable && props.onExpandClick && (
                <motion.div
                    {...conditionalScaleAnimation(true, ANIMATION_BIGGER, ANIMATION_SMALLER)}
                    style={{
                        height: '29px'
                    }}
                >
                    <S_ExpandIcon
                        icon={[props.icon.iconPrefix, props.expanded ? 'xmark' : 'arrows-up-down']}
                    />
                </motion.div>
            )}
        </S_SidebarSubsectionHeader>
    );
};

const S_SidebarSubsectionHeader = styled.div<{ $expandable: boolean }>`
    display: flex;
    width: 100%;
    color: #141c54;
    background: transparent;
    flex-direction: row;
    padding: 9px 15px 10px 15px;
    align-items: center;
    border-bottom: none;
    cursor: default;
    user-select: none;
`;

const S_HeaderIcon = styled(FontAwesomeIcon)`
    font-size: 20px;
    margin: 0 15px 0 0;
    width: 20px;
`;

const S_HeaderTitle = styled.div`
    font-family: ${EFonts.Regular};
    font-size: 14px;
    margin-right: auto;
    margin-left: 0;
    padding: 6px 0;
`;

const S_ExpandIcon = styled(FontAwesomeIcon)`
    padding: 5px;
    font-size: 20px;
    justify-self: end;
    margin-left: auto;
    cursor: pointer;
`;
